export const featureFlags = {
  // ❗ When the flag is activated,
  // ❗ ALL USERS ARE LOGGED OUT due to migration from Cognito to cookie storage.
  hasStockAppNav: true // TODO remove and clean up in separate PR
}
